export default __webpack_public_path__ + "static/media/ebooksBanner.c876da95.webp";